import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import List from '../../component/campusDrive/listDrive';
import { campusDriveList, updateCampusDriveStatus } from '../../actions/campusDriveAction';

const CampusDriveListContainer = () => {

    const [list, setList] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        loadList();
    }, []);

    const loadList = () => {
        campusDriveList({ page: 1 }).then((res) => {
            if (res.status) {
                setList(res.result.list);
            }
        });
    };

    const handleEdit = (id) => {
        navigate(`/admin/campus-drive/edit/${id}`);
    };

    const handleStatusChange = (id, currentStatus) => {
        const newStatus = currentStatus === 'PUBLISHED' ? 'CANCELLED' : 'PUBLISHED';

        updateCampusDriveStatus({
            ID: id,
            STATUS: newStatus
        }).then((res) => {
            if (res.status) {
                loadList(); // refresh list
            }
        });
    };

    return (
        <React.Fragment>
            <List
                list={list}
                onEdit={handleEdit}
                onStatusChange={handleStatusChange}
            />
        </React.Fragment>
    );
};

export default CampusDriveListContainer;
